import { cx } from "../utils/cx";

export function Field({
  label,
  hint,
  className,
  inputClassName,
  prefix,
  suffix,
  ...inputProps
}) {
  const isDisabled = inputProps.disabled || inputProps.readOnly;

  return (
    <label className={cx("field", className)}>
      <span className="field-label">{label}</span>
      {hint ? <span className="field-hint">{hint}</span> : null}
      <div className={cx("input-shell", isDisabled && "is-disabled")}>
        {prefix ? <span className="input-prefix">{prefix}</span> : null}
        <input className={cx("text-input", inputClassName)} {...inputProps} />
        {suffix ? <span className="input-prefix is-suffix">{suffix}</span> : null}
      </div>
    </label>
  );
}

export function SelectField({ label, hint, className, children, ...props }) {
  const isDisabled = props.disabled || props.readOnly;

  return (
    <label className={cx("field", className)}>
      <span className="field-label">{label}</span>
      {hint ? <span className="field-hint">{hint}</span> : null}
      <select className={cx("select-input", isDisabled && "is-disabled")} {...props}>
        {children}
      </select>
    </label>
  );
}

export function TextAreaField({ label, hint, className, ...props }) {
  return (
    <label className={cx("field", className)}>
      <span className="field-label">{label}</span>
      {hint ? <span className="field-hint">{hint}</span> : null}
      <textarea className="textarea-input" {...props} />
    </label>
  );
}

export function ReadOnlyValueField({
  badge = "Locked",
  className,
  hint,
  label,
  value,
}) {
  return (
    <div className={cx("field", "field-readonly", className)}>
      <span className="field-label">{label}</span>
      {hint ? <span className="field-hint">{hint}</span> : null}
      <div aria-readonly="true" className="readonly-value-shell">
        <span className="readonly-value-text">{value || "Not set"}</span>
        {badge ? <span className="readonly-value-badge">{badge}</span> : null}
      </div>
    </div>
  );
}

export function ToggleField({ label, description, checked, onChange }) {
  return (
    <label className="toggle-field">
      <div>
        <span className="field-label">{label}</span>
        {description ? <span className="field-hint">{description}</span> : null}
      </div>

      <button
        aria-pressed={checked}
        className={cx("toggle-switch", checked && "is-on")}
        type="button"
        onClick={() => onChange(!checked)}
      >
        <span className="toggle-thumb" />
      </button>
    </label>
  );
}
